import { useOnboardingStore } from '../../stores/useOnboardingStore';
import styles from './OnboardingButton.module.css';

const RADIUS = 11;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const OnboardingButton = () => {
  const isLoaded = useOnboardingStore((s) => s.isLoaded);
  const completionPct = useOnboardingStore((s) => s.completionPct);
  const toggleChecklist = useOnboardingStore((s) => s.toggleChecklist);

  if (!isLoaded || completionPct >= 100) return null;

  const offset = CIRCUMFERENCE - (completionPct / 100) * CIRCUMFERENCE;

  return (
    <div className={styles.container} data-floating-widget="onboarding">
      <button className={styles.button} onClick={toggleChecklist}>
        <div className={styles.progressRing}>
          <svg
            className={styles.progressRingSvg}
            width="28"
            height="28"
            viewBox="0 0 28 28"
          >
            <circle
              className={styles.progressRingBg}
              cx="14"
              cy="14"
              r={RADIUS}
            />
            <circle
              className={styles.progressRingFg}
              cx="14"
              cy="14"
              r={RADIUS}
              strokeDasharray={CIRCUMFERENCE}
              strokeDashoffset={offset}
            />
          </svg>
        </div>
        <span>Configurar ({completionPct}%)</span>
      </button>
    </div>
  );
};

export default OnboardingButton;
